<script>
// import loader from "@/components/Loader.vue";
import store from "../../vuex/store";

export default {
  name: "ButtonWithLoading",
  components: {
    // loader,
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "button",
    },
    shaked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isLoading() {
      return store?.getters.isLoading;
    },
  },
  emits: ["onClick"],
};
</script>

<template>
  <button
    :disabled="isDisabled || isLoading"
    class="navbar_btn"
    :class="{ button__loading: isLoading, shaked: shaked }"
    :type="type"
    @click="$emit('onClick')"
  >
    <span>{{ title }}</span>
    <!-- <loader v-if="isLoading" :isLoading="isLoading" /> -->

    <!-- <svg v-show="isLoading" class="svg_icon_loader">
      <use class="rotate-svg" xlink:href="@/assets/img/Loader.svg#loader"></use>
    </svg> -->

    <slot></slot>
  </button>
</template>

<style scoped lang="scss">
@keyframes btn-shake {
  0% {
    transform: rotate(0deg);
  }
  1% {
    transform: rotate(-2deg);
  }
  2% {
    transform: rotate(0deg);
  }
  3% {
    transform: rotate(2deg);
  }
  4% {
    transform: rotate(0deg);
  }
  5% {
    transform: rotate(-2deg);
  }
  6% {
    transform: rotate(0deg);
  }
  7% {
    transform: rotate(-2deg);
  }
  8% {
    transform: rotate(0deg);
  }
  9% {
    transform: rotate(2deg);
  }
  10% {
    transform: rotate(0deg);
  }
}
.text-btn {
  font-size: 18px;
}
.navbar_btn {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  color: #f8fafc;
  line-height: 24px;
  border-radius: 6px;
  padding: 4px 8px;
  border: 1px solid;
  background: #3056d3;
  transition: all ease-in-out 300ms;

  &.shaked {
    animation-name: btn-shake;
    animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    animation-delay: 0s;
  }

  &:disabled {
    opacity: 0.5;

    &:hover {
      color: #f8fafc;
      background: #3056d3;
      border: 1px solid;
    }
  }

  &:hover {
    background: #fff;
    color: #3056d3;
    border: 1px solid #3056d3;
  }
}

.svg_icon_loader {
  width: 30px;
  height: 30px;
  fill: #f8fafc;
}

.rotate-svg {
  animation: rotate 4s linear infinite;
  transform-origin: center;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
